<template>
  <div class="integrating-park">
    <h1>統合公園</h1>
    <el-dialog
      title="人民の義務を履行する"
      :visible.sync="visibleClaimDialog"
      width="80%">
      <span>この声を人民安定省に報告しますか？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleClaimDialog = false">思いとどまる</el-button>
        <el-button type="primary" @click="claimUser()">報告する</el-button>
      </span>
    </el-dialog>
    <svg :viewbox="'0 0 ' + width + ' ' +  height" :width="width" :height="height">
      <template v-for="text of texts">
        <text v-for="partText of text.partialTexts"
              :key="partText.id"
              :x="partText.x"
              :y="partText.y"
              :opacity="partText.opacity"
              :fill="partText.color"
              :font-size="partText.fontSize"
              :transform="'rotate(' + partText.rotateZ + ')' + ' translate(' + partText.translateX + ',' + partText.translateY + ')'"
              style="cursor: pointer;"
              v-on:mouseover="stopTextMove(text)"
              v-on:click="showMenuOnText(text)">
          {{ partText.texts }}
        </text>
      </template>
    </svg>
    <el-row>
      <el-col :span="18">
        <el-input placeholder="あなたの言葉"
        v-model="voice"
        :readonly="isVoiceDefined"
        @keydown.enter.native="utter">
        </el-input>
      </el-col>
      <el-col :span="6">
        <el-button type="primary" class="orange" v-on:click="utter">声を上げる</el-button></el-col>
    </el-row>
  </div>
</template>

<script>
import { Message } from 'element-ui'
import firestore from '../firestore'
import firebase from 'firebase'

export default {
  name: 'IntegratingPark',
  methods: {
    handleResize: function () {
      this.width = window.innerWidth - 20
      this.height = window.innerHeight - 200
    },
    addTextAsGravitation: function (id, userName, str, color) {
      if (id in this.textKeys) {
        return
      }
      this.texts.push({
        stopCount: 0,
        userName: userName,
        style: 'gravitation',
        partialTexts: [{
          id: id,
          x: Math.random() * this.width / 2,
          y: this.height,
          color: color,
          xSpeed: 6,
          ySpeed: -20,
          texts: str,
          opacity: 1.0,
          fontSize: 24,
          translateX: 0,
          translateY: 0,
          rotateZ: 0
        }]
      })
      this.textKeys[id] = {id: id}
    },
    addTextAsStamp: function (id, userName, str, color) {
      if (id in this.textKeys) {
        return
      }
      if (!str) {
        return
      }
      let partialTexts = []
      let currentX = Math.random() * this.width / 2
      let currentY = Math.random() * this.height / 2

      for (let i = 0; i < str.length; i++) {
        partialTexts.push({
          id: id + String(i),
          x: currentX,
          y: currentY,
          color: color,
          fontSize: 102,
          texts: str[i],
          waitFor: i * 10 + 1,
          opacity: 0.0,
          translateX: 0,
          translateY: 0,
          rotateZ: 0
        })
        currentY += 24
        currentX += Math.random() * (10) - 5
      }
      partialTexts.push({
        id: id + String(-1),
        x: 0,
        y: 0,
        color: color,
        fontSize: 24,
        texts: '',
        waitFor: str.length * 50,
        opacity: 0,
        translateX: 0,
        translateY: 0,
        rotateZ: 0
      })

      this.texts.push({
        stopCount: 0,
        userName: userName,
        style: 'stamp',
        partialTexts: partialTexts
      })
      this.textKeys[id] = {id: id}
    },
    addTextAsImpact: function (id, userName, str, color) {
      if (id in this.textKeys) {
        return
      }
      if (!str) {
        return
      }
      const x = (Math.random() * this.width)
      const y = (Math.random() * (this.height - 24)) + 24

      let partialTexts = []
      for (let i = 0; i < str.length; i++) {
        partialTexts.push({
          id: id + String(i),
          x: x,
          y: y,
          color: color,
          texts: str[i],
          opacity: 0,
          fontSize: 24,
          waitFor: i * 15 + 1,
          translateX: 0,
          translateY: 0,
          rotateZ: 0
        })
      }
      partialTexts.push({
        id: id + String(-1),
        x: 0,
        y: 0,
        color: color,
        fontSize: 24,
        texts: '',
        waitFor: str.length * 50,
        opacity: 0,
        translateX: 0,
        translateY: 0,
        rotateZ: 0
      })

      this.texts.push({
        stopCount: 0,
        userName: userName,
        style: 'impact',
        partialTexts: partialTexts
      })
      this.textKeys[id] = {id: id}
    },
    addTextAsRound: function (id, userName, str, color) {
      if (id in this.textKeys) {
        return
      }
      if (!str) {
        return
      }
      const x = (Math.random() * this.width / 2)
      const y = (Math.random() * this.height / 2)

      let partialTexts = []
      const colors = [
        '#E60012',
        '#F39800',
        '#FFF100',
        '#009944',
        '#0068B7',
        '#1D2088',
        '#920783',
        color
      ]
      var baseR = 10
      for (let i = 0; i < 8; i++) {
        var rad = 360 * i / 8 * (Math.PI / 180)
        partialTexts.push({
          id: id + String(i),
          baseX: x,
          baseY: y,
          baseR: baseR,
          color: colors[i],
          x: Math.cos(rad) * baseR + x,
          y: Math.sin(rad) * baseR + y,
          texts: str[0],
          opacity: 1.0,
          fontSize: 24,
          translateX: 0,
          translateY: 0,
          rotateZ: 0,
          rad: i
        })
      }
      if (str.length > 1) {
        partialTexts.push({
          id: id + 'const',
          x: x + 30,
          y: y,
          color: color,
          texts: str.substring(1),
          opacity: 1.0,
          fontSize: 24,
          translateX: 0,
          translateY: 0,
          rotateZ: 0,
          rad: null
        })
      }

      this.texts.push({
        stopCount: 0,
        moveCount: 100,
        userName: userName,
        style: 'round',
        partialTexts: partialTexts
      })
      this.textKeys[id] = {id: id}
    },
    addTextAsShake: function (id, userName, str, color) {
      if (id in this.textKeys) {
        return
      }
      this.texts.push({
        stopCount: 0,
        userName: userName,
        style: 'shake',
        moveCount: 100,
        partialTexts: [{
          id: id,
          x: Math.random() * this.width / 2,
          y: Math.random() * this.height / 2,
          color: color,
          xSpeed: 6,
          ySpeed: -20,
          texts: str,
          opacity: 1.0,
          fontSize: 24,
          shakeTime: 0,
          translateX: 0,
          translateY: 0,
          rotateZ: 0
        }]
      })
      this.textKeys[id] = {id: id}
    },
    addTextAsCombine: function (id, userName, str, color) {
      if (id in this.textKeys) {
        return
      }
      if (!str) {
        return
      }
      const x = (Math.random() * (this.width - (str.length * 24)))
      const y = (Math.random() * this.height)

      let partialTexts = []
      for (let i = 0; i < str.length; i++) {
        const currentX = (Math.random() * this.width)
        const currentY = (Math.random() * this.height)
        const currentRotate = Math.random() * 360

        const moveX = (x + (24) * i - currentX) / 100
        const moveY = (y - currentY) / 100
        const moveRotate = (0 - currentRotate) / 100

        partialTexts.push({
          id: id + String(i),
          moveX: moveX,
          moveY: moveY,
          moveRotate: moveRotate,
          x: currentX,
          y: currentY,
          color: color,
          texts: str[i],
          opacity: 1.0,
          fontSize: 24,
          moveCount: 101,
          translateX: 0,
          translateY: 0,
          rotateZ: 0
        })
      }

      this.texts.push({
        stopCount: 0,
        moveCount: 300,
        userName: userName,
        style: 'combine',
        partialTexts: partialTexts
      })
      this.textKeys[id] = {id: id}
    },
    addText: function (id, userName, str, style, color) {
      if (style === 'gravitation') {
        this.addTextAsGravitation(id, userName, str, color)
      } else if (style === 'stamp') {
        this.addTextAsStamp(id, userName, str, color)
      } else if (style === 'impact') {
        this.addTextAsImpact(id, userName, str, color)
      } else if (style === 'round') {
        this.addTextAsRound(id, userName, str, color)
      } else if (style === 'shake') {
        this.addTextAsShake(id, userName, str, color)
      } else if (style === 'combine') {
        this.addTextAsCombine(id, userName, str, color)
      }
    },
    addMoveAsGravitation: function (text) {
      let hasValidPartialText = false
      for (let j = 0; j < text.partialTexts.length; j++) {
        var partialTexts = text.partialTexts[j]
        partialTexts.x = partialTexts.x + partialTexts.xSpeed
        partialTexts.y = partialTexts.y + partialTexts.ySpeed
        partialTexts.ySpeed += 0.98
        if (partialTexts.y <= this.height) {
          hasValidPartialText = true
        }
      }
      return hasValidPartialText
    },
    addMoveAsStamp: function (text) {
      let hasWaitText = false
      let hasScaledText = false
      for (let j = 0; j < text.partialTexts.length; j++) {
        var partialTexts = text.partialTexts[j]
        if (partialTexts.waitFor > 0) {
          partialTexts.waitFor -= 1
          if (partialTexts.waitFor <= 0) {
            partialTexts.opacity = 1
            partialTexts.fontSize = 102
          } else {
            hasWaitText = true
          }
        }
        if (partialTexts.fontSize >= 24) {
          partialTexts.fontSize -= 2
          hasScaledText = true
        }
      }
      return hasScaledText || hasWaitText
    },
    addMoveAsImpact: function (text) {
      let hasWaitText = false
      for (let j = 0; j < text.partialTexts.length; j++) {
        var partialTexts = text.partialTexts[j]
        if (partialTexts.waitFor > 0) {
          partialTexts.waitFor -= 1
          if (partialTexts.waitFor <= 0) {
            partialTexts.opacity = 1
            partialTexts.fontSize = 48
          } else {
            hasWaitText = true
          }
        } else {
          partialTexts.opacity =
            Math.max(partialTexts.opacity - 0.05, 0)
        }
      }
      return hasWaitText
    },
    addMoveAsRound: function (text) {
      for (let j = 0; j < text.partialTexts.length; j++) {
        var partialTexts = text.partialTexts[j]
        if (partialTexts.rad == null) {
          continue
        }
        partialTexts.rad = (partialTexts.rad + 1) % 49
        var rad = 360 * partialTexts.rad / 49 * (Math.PI / 180)
        partialTexts.x = partialTexts.baseX + Math.sin(rad) * partialTexts.baseR
        partialTexts.y = partialTexts.baseY + Math.cos(rad) * partialTexts.baseR
      }
      text.moveCount -= 1
      return text.moveCount >= 0
    },
    addMoveAsShake: function (text) {
      for (let j = 0; j < text.partialTexts.length; j++) {
        var partialTexts = text.partialTexts[j]
        partialTexts.shakeTime = (partialTexts.shakeTime + 1) % 4
        switch (partialTexts.shakeTime) {
          case 0:
            partialTexts.translateX = 0
            partialTexts.translateY = 0
            partialTexts.rotateZ = 0
            break
          case 1:
            partialTexts.translateX = 2
            partialTexts.translateY = 2
            partialTexts.rotateZ = 1
            break
          case 2:
            partialTexts.translateX = 0
            partialTexts.translateY = 2
            partialTexts.rotateZ = 0
            break
          case 3:
            partialTexts.translateX = 2
            partialTexts.translateY = 0
            partialTexts.rotateZ = -1
            break
        }
      }
      text.moveCount -= 1
      return text.moveCount >= 0
    },
    addMoveAsCombine: function (text) {
      for (let j = 0; j < text.partialTexts.length; j++) {
        var partialTexts = text.partialTexts[j]
        partialTexts.moveCount -= 1
        if (partialTexts.moveCount >= 1) {
          partialTexts.x += partialTexts.moveX
          partialTexts.y += partialTexts.moveY
        }
        // partialTexts.rotateZ += partialTexts.moveRotate
      }

      text.moveCount -= 1
      return text.moveCount >= 0
    },
    countTime: function () {
      const validArray = []
      for (let i = 0; i < this.texts.length; i++) {
        const text = this.texts[i]
        let hasValidPartialText = false

        if (text.stopCount >= 1) {
          text.stopCount -= 1
          validArray.push(text)
          continue
        }
        if (text.style === 'gravitation') {
          hasValidPartialText = this.addMoveAsGravitation(text)
        } else if (text.style === 'stamp') {
          hasValidPartialText = this.addMoveAsStamp(text)
        } else if (text.style === 'impact') {
          hasValidPartialText = this.addMoveAsImpact(text)
        } else if (text.style === 'round') {
          hasValidPartialText = this.addMoveAsRound(text)
        } else if (text.style === 'shake') {
          hasValidPartialText = this.addMoveAsShake(text)
        } else if (text.style === 'combine') {
          hasValidPartialText = this.addMoveAsCombine(text)
        }
        if (hasValidPartialText) {
          validArray.push(text)
        }
      }
      this.texts = validArray

      this.handleCloseTime()
    },
    utter: function () {
      if (!this.voice) {
        Message.error('何か言いましたか？')
      }
      const rand = Math.floor(Math.random() * 6)
      let style = ''
      if (rand === 0) {
        style = 'gravitation'
      } else if (rand === 1) {
        style = 'stamp'
      } else if (rand === 2) {
        style = 'impact'
      } else if (rand === 3) {
        style = 'round'
      } else if (rand === 4) {
        style = 'shake'
      } else if (rand === 5) {
        style = 'combine'
      }
      firestore.collection('miserable-voice').add({
        userName: localStorage.name,
        uid: localStorage.uid,
        voice: this.voice,
        style: style,
        color: this.color,
        created: Date.now()
      })
      this.voice = ''
    },
    showMenuOnText: function (text) {
      text.stopCount = 100
      this.claimTargetuserName = text.userName
      this.visibleClaimDialog = true
    },
    stopTextMove: function (text) {
      text.stopCount = 100
    },
    handleCloseTime: function () {
      if (this.debug === true) {
        return
      }
      const currentDate = new Date()
      const hour = currentDate.getHours()
      if (hour !== 23) {
        Message.info('時間になったので、広場は閉鎖されました。')
        this.$router.push('/')
      }
    },
    claimUser: function (userName) {
      if (Math.floor(Math.random() * 5) + 1 >= 4) {
        firestore.collection('name-user').doc(localStorage.name).set({
          isPurged: true
        })
      } else {
        firestore.collection('name-user').doc(this.claimTargetuserName).set({
          isPurged: true
        })
      }
      this.visibleClaimDialog = false
    },
    getRandomColor: function () {
      const colors = [
        '#00947a',
        '#4d4398',
        '#3c7170',
        '#c1ab05',
        '#9f166a',
        '#618e34',
        '#736d71',
        '#24140e',
        '#003f8e',
        '#c82c55',
        '#946c45'
      ]

      return colors[Math.floor(Math.random() * colors.length)]
    }
  },
  data () {
    return {
      texts: [],
      textKeys: {},
      color: this.getRandomColor(),
      voice: '',
      width: 300,
      height: 300,
      visibleClaimDialog: false,
      claimTargetuserName: '',
      isVoiceDefined: false,
      debug: true
    }
  },
  mounted: function () {
    let self = this
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        localStorage.uid = user.uid
      } else {
        Message.error('あなたは国民として認知されていません。')
        self.$router.push('/')
      }
    })

    this.handleResize()
    const currentTime = Date.now()
    this.timerObj = setInterval(function () { self.countTime() }, 20)
    if (!localStorage.name) {
      Message.error('あなたは国民として認知されていません。')
      self.$router.push('/')
    }
    firestore.collection('miserable-voice')
      .where('created', '>=', currentTime)
      .onSnapshot(function (snapshot) {
        snapshot.forEach(function (doc) {
          self.addText(doc.id, doc.data().userName, doc.data().voice, doc.data().style, doc.data().color)
        })
      })

    firestore.collection('name-user').doc(localStorage.name)
      .onSnapshot(function (doc) {
        if (doc.data().isPurged) {
          Message.error('おめでとうございます。あなたは模範市民として教育を受ける権利を得ました。')
          self.$router.push('/')
        }
      })
    firestore.collection('setting').doc('common').get().then(
      function (setting) {
        console.log(setting.data())
        self.debug = setting.data().debug
      }
    )
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
    window.clearInterval(this.timerObj)
  },
  computed: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.orange {
  background-color: #e1441b;
  border-color: #e1441b;
}
svg text:hover { fill: #fce57e; }
</style>



// WEBPACK FOOTER //
// src/components/IntegratingPark.vue